"use strict";
exports.__esModule = true;
exports.PROPERTY_TYPES = void 0;
exports.PROPERTY_TYPES = [
    'HOTEL',
    'MOTEL',
    'VILLA',
    'APART_HOTEL',
    'INN',
    'APARTMENT',
    'CONDO',
    'COTTAGE',
    'CABIN',
    'CASTLE',
    'CHALET',
    'CAMPSITE',
    'CONDOMINIUM_RESORT',
    'COUNTRY_HOUSE',
    'CRUISE',
    'GUEST_HOUSE',
    'HOLIDAY_PARK',
    'HOSTEL',
    'HOUSE_BOAT',
    'LODGE',
    'PALACE',
    'PENSION',
    'PRIVATE_VACATION_HOME',
    'RANCH',
    'RESIDENCE',
    'RYOKAN',
    'RIAD',
    'TOWNHOUSE',
    'TREE_HOUSE',
];
//# sourceMappingURL=property.constants.js.map